import React from "react";

function DsdvPage() {
  return <h1>DSDV Notes</h1>;
}

export default DsdvPage;